import { render, staticRenderFns } from "./QAgentLookup.vue?vue&type=template&id=96f83b30&"
import script from "./QAgentLookup.vue?vue&type=script&lang=js&"
export * from "./QAgentLookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports